import { render } from "./DeliveryClientOrdersActionMenu.vue?vue&type=template&id=2e3be3e6&scoped=true"
import script from "./DeliveryClientOrdersActionMenu.vue?vue&type=script&lang=js"
export * from "./DeliveryClientOrdersActionMenu.vue?vue&type=script&lang=js"

import "./DeliveryClientOrdersActionMenu.vue?vue&type=style&index=0&id=2e3be3e6&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e3be3e6"]])

export default __exports__